import { Outlet } from "react-router-dom";

function PayablesMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default PayablesMain;